<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import FilterOptions from "@/components/Dashboard/Devices/HardwareReport/FilterOptions.vue";
import HardwareReportTable from "@/components/Dashboard/Devices/HardwareReport/HardwareReportTable.vue";
</script>
<template>
  <ContentHeader :name="'Hardware Report'" />
  <FilterOptions />
  <HardwareReportTable />
</template>

<style scoped></style>
